import request from "root/js/request";

export const getSupplyDistributionLogisticTableExport = async ({
  wb_api_key_ids,
  sales_share_history_period,
  order_by,
  tariff_date,
}) => {
  const response = await request({
    url: "/analytics/forecasting/warehouse_supply_distribution_logistic_cost/export/",
    method: "post",
    params: {
      wb_api_key_ids,
      sales_share_history_period,
      order_by,
      tariff_date,
    },
  });
  return response.data;
};
